export default "__VITE_ASSET__BNhij5zT__"